import {Injectable} from '@angular/core';
import {AdminClustersComponent} from 'app/Menus/AdminClusters/adminClusters.component';
import {AdminTermsAndConditionsComponent} from 'app/Menus/AdminTermsAndConditions/adminTermsAndConditions.component';
import {AuthFlowSetupComponent} from 'app/Menus/AuthFlowSetup/authFlowSetup.component';
import {AuthFlowSetupEditComponent} from 'app/Menus/AuthFlowSetup/authFlowSetupEdit.component';
import {MailTemplateComponent} from 'app/Menus/MailTemplate/mailTemplate.component';
import {NotificationBuilder} from 'app/Menus/NotificationBuilder/notificationBuilder.component';
import {NotificationBuilderDetails} from 'app/Menus/NotificationBuilderDetails/notificationBuilderDetails.component';
import {OnBoardingDocsComponent} from 'app/Menus/OnBoardingDocs/onBoardingDocs.component';
import {OnBoardingDocsAMLComponent} from 'app/Menus/OnBoardingDocsAML/onBoardingDocsAML.component';
import {OnBoardingDocsKYCComponent} from 'app/Menus/OnBoardingDocsKYC/onBoardingDocsKYC.component';
import {ResendInvitationComponent} from 'app/Menus/ResendInvitation/resendInvitation.component';
import {AdminDocumentTypesComponent} from '../../Menus/AdminDocumentTypes/adminDocumentTypes.component';
import {ApproveClientUploadComponent} from '../../Menus/ApproveClientUpload/approveClientUpload.component';
import {ApproveDebtorUploadComponent} from '../../Menus/ApproveDebtorUpload/approveDebtorUpload.component';
import {ClaccFinanceRequestComponent} from '../../Menus/ClaccFinanceRequest/claccFinanceRequest.component';
import {CreditnotesClientBatchComponent} from '../../Menus/CreditnotesClientBatch/creditnotesClientBatch.component';
import {CreditnotesDebtorBatchComponent} from '../../Menus/CreditnotesDebtorBatch/creditnotesDebtorBatch.component';
import {DemandApprovalRequestComponent} from '../../Menus/DemandApprovalRequest/demandApprovalRequest.component';
import {DemandDisputeRequestComponent} from '../../Menus/DemandDisputeRequest/demandDisputeRequest.component';
import {DemandFinanceRequestComponent} from '../../Menus/DemandFinanceRequest/demandFinanceRequest.component';
import {DocumentsComponent} from '../../Menus/Documents/documents.component';
import {FileUploaderComponent} from '../../Menus/FileUploader/fileUploader.component';
import {FourEyesAdminPanelComponent} from '../../Menus/FourEyesAdminPanel/fourEyesAdminPanel.component';
import {HomeComponent} from '../../Menus/Home/home.component';
import {PaymentsClientBatchComponent} from '../../Menus/PaymentsClientBatch/paymentsClientBatch.component';
import {PaymentsDebtorBatchComponent} from '../../Menus/PaymentsDebtorBatch/paymentsDebtorBatch.component';
import {ReceivablesClientBatchComponent} from '../../Menus/ReceivablesClientBatch/receivablesClientBatch.component';
import {ReceivablesDebtorBatchComponent} from '../../Menus/ReceivablesDebtorBatch/receivablesDebtorBatch.component';
import {TrackInvitations} from '../../Menus/TrackInvitations/trackInvitations.component';
import {TrackInvitationsDetails} from '../../Menus/TrackInvitationsDetails/trackInvitationsDetails.component';

@Injectable()
export class WebXmlComponent {
  public getComponent(name: string) {
    switch (name) {
      case 'DocumentsComponent':
        return DocumentsComponent;
      case 'FileUploaderComponent':
        return FileUploaderComponent;
      case 'DemandApprovalRequestComponent':
        return DemandApprovalRequestComponent;
      case 'ReceivablesClientBatchComponent':
        return ReceivablesClientBatchComponent;
      case 'ReceivablesDebtorBatchComponent':
        return ReceivablesDebtorBatchComponent;
      case 'CreditnotesClientBatchComponent':
        return CreditnotesClientBatchComponent;
      case 'CreditnotesDebtorBatchComponent':
        return CreditnotesDebtorBatchComponent;
      case 'PaymentsClientBatchComponent':
        return PaymentsClientBatchComponent;
      case 'PaymentsDebtorBatchComponent':
        return PaymentsDebtorBatchComponent;
      case 'ApproveClientUploadComponent':
        return ApproveClientUploadComponent;
      case 'TrackInvitations':
        return TrackInvitations;
      case 'TrackInvitationsDetails':
        return TrackInvitationsDetails;
      case 'ApproveDebtorUploadComponent':
        return ApproveDebtorUploadComponent;
      case 'DemandDisputeRequestComponent':
        return DemandDisputeRequestComponent;
      case 'ClaccFinanceRequestComponent':
        return ClaccFinanceRequestComponent;
      case 'DemandFinanceRequestComponent':
        return DemandFinanceRequestComponent;
      case 'AdminDocumentTypesComponent':
        return AdminDocumentTypesComponent;
      case 'ResendInvitationComponent':
        return ResendInvitationComponent;
      case 'AdminClustersComponent':
        return AdminClustersComponent;
      case 'OnBoardingDocsComponent':
        return OnBoardingDocsComponent;
      case 'OnBoardingDocsKYCComponent':
        return OnBoardingDocsKYCComponent;
      case 'OnBoardingDocsAMLComponent':
        return OnBoardingDocsAMLComponent;
      case 'MailTemplateComponent':
        return MailTemplateComponent;
      case 'AuthFlowSetupComponent':
        return AuthFlowSetupComponent;
      case 'AuthFlowSetupEditComponent':
        return AuthFlowSetupEditComponent;
      case 'AdminTermsAndConditionsComponent':
        return AdminTermsAndConditionsComponent;
      case 'NotificationBuilder':
        return NotificationBuilder;
      case 'NotificationBuilderDetails':
        return NotificationBuilderDetails;
      case 'FourEyesAdminPanelComponent':
        return FourEyesAdminPanelComponent;

      default:
        return HomeComponent;
    }
  }
}
